/**
 * CDS (Camino Design System) Colors
 * Source: Design system camino.pdf
 *
 * These are the canonical color palettes for the Camino design system.
 */

const cdsColors = {
  // Brand (Blue)
  brand: {
    DEFAULT: "#4F7AEF",
    50: "#EFF6FF",
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#4F7AEF",
    600: "#3D5FE6",
    700: "#2F4BC9",
    800: "#1A2780",
    900: "#0A043C",
  },

  // Indigo
  cdsIndigo: {
    DEFAULT: "#6366F1",
    50: "#EEF2FF",
    100: "#E0E7FF",
    200: "#C7D2FE",
    300: "#A5B4FC",
    400: "#818CF8",
    500: "#6366F1",
    600: "#4F46E5",
    700: "#4338CA",
    800: "#3730A3",
    900: "#312E81",
  },

  // Cyan
  cdsCyan: {
    DEFAULT: "#06B6D4",
    50: "#ECFEFF",
    100: "#CFFAFE",
    200: "#A5F3FC",
    300: "#67E8F9",
    400: "#22D3EE",
    500: "#06B6D4",
    600: "#0891B2",
    700: "#0E7490",
    800: "#155E75",
    900: "#164E63",
  },

  // Green
  cdsGreen: {
    DEFAULT: "#83D97B",
    50: "#F0FAF0",
    100: "#DBF3DA",
    200: "#C3EDC2",
    300: "#A9E7A6",
    400: "#95E090",
    500: "#83D97B",
    600: "#78C970",
    700: "#6BB564",
    800: "#60A359",
    900: "#3D6838",
  },

  // Orange
  cdsOrange: {
    DEFAULT: "#F59511",
    50: "#FEF3E0",
    100: "#FCDFB3",
    200: "#FACA81",
    300: "#F8B550",
    400: "#F6A62C",
    500: "#F59511",
    600: "#F18B0F",
    700: "#EB7B0C",
    800: "#E56C0A",
    900: "#DB5508",
  },

  // Red
  cdsRed: {
    DEFAULT: "#EE522F",
    50: "#FEF2F2",
    100: "#FFCFD0",
    200: "#ED9D97",
    300: "#E37970",
    400: "#EB5D4B",
    500: "#EE522F",
    600: "#E0492F",
    700: "#CE3F2A",
    800: "#C13923",
    900: "#B22F17",
  },

  // Grey (Black scale)
  cdsGrey: {
    DEFAULT: "#3A3A3A",
    50: "#F9F9F9",
    100: "#F2F2F2",
    200: "#E8E8E8",
    300: "#D8D8D8",
    400: "#B4B4B4",
    500: "#949494",
    600: "#6C6C6C",
    700: "#585858",
    800: "#3A3A3A",
    900: "#1A1A1A",
  },
} as const;

export type CdsColors = typeof cdsColors;
export default cdsColors;
